import React from "react";
import EventIcon from "@mui/icons-material/Event";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Card from "components/common/card/Card.component";

const DownloadCardComponent = ({
  dateSelected,
  title,
  onDownload = () => { },
}) => {
  const { t } = useTranslation();

  return (
    <Card>
      <Grid container spacing={2} display="flex" alignItems="center">
        <Grid item xs={6}>
          <Box display="flex" alignItems="center">
            <EventIcon fontSize="large" />
            <Box ml={1}>
              <Typography>{t("Selected date")}</Typography>
              {dateSelected ? (
                <Typography variant="h5" textTransform="capitalize" noWrap>
                  {dateSelected}
                </Typography>
              ) : (
                <Typography variant="h5">{t("No date selected")}</Typography>
              )}
            </Box>
          </Box>
        </Grid>

        {dateSelected && (
          <Grid item container xs={6} spacing={1}>
            <Grid item xs={12}>
              <Typography variant="h5" align="center">
                {title}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                size="small"
                variant="contained"
                onClick={onDownload}
                sx={{ width: "100%" }}
              >
                {t("Download")}
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default DownloadCardComponent;
